module.exports = __webpack_public_path__ + "img/empty.6ad6cf9f.png";